import React, {useState} from 'react';
import './Cover.css';
import {Avatar} from '@material-ui/core';

function Cover({profilePic, coverPic, username, email}) {
    const [close, setClose] = useState(false);
    const closePostBox = () => {
        setClose(!close);
    }
    const showCreateBox = () => {
        setClose(true);
    }
    
    return (
        <div className="cover" id="cover">
            <div className="cover__outside"
            > 
                <div className="cover__inner"
                style={{backgroundImage:`url(${coverPic})`}} >
                </div>
                <div className="bottom__dark" />
                <div className="profile__avatar">
                    <Avatar src={profilePic} className="pic__avatar" />
                    <h2>{username}</h2>
                    <p>{email}</p>
                </div>
            </div>
           
        </div>
    )
}

export default Cover
